import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initializeIcons } from '@fluentui/react';
import App from './App';
import Admin from './Admin';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';

initializeIcons();

export default function LogBook() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route index element={<App />} />
            <Route path="admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <LogBook />
);

